export const APP_VERSION = import.meta.env.PACKAGE_VERSION;
export const DISCORD_LINK = "https://discord.gg/v8aeejke";
export const GITHUB_LINK = "https://github.com/nexiloop";
export const TWITTER_LINK = "https://twitter.com/ovlop";
export const GA_ID = import.meta.env.VITE_GA_ID;
export const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
// Do it clap??
